# Array methods

if typeof Array.map is 'undefined'
  Object.defineProperty Array, 'map', value: (callbackFn = ((item) => item), arrays...) ->
    length = arrays.min((array) => array.length); results = []
    results[index] = callbackFn.apply null, arrays.map((array) => array[index]) for index in [0 ... length]
    results

if typeof Array.zip is 'undefined'
  Object.defineProperty Array, 'zip', value: (callbackFn = ((item) => item), arrays...) ->
    arrays[0].map((_, index) => callbackFn(arrays.map((array) => array[index])...))

if typeof Array.prototype.uniq is 'undefined'
  Object.defineProperty Array.prototype, 'uniq', value: () ->
    [new Set(@)...]

if typeof Array.prototype.compact is 'undefined'
  Object.defineProperty Array.prototype, 'compact', value: () ->
    @filter (item) => item?

if typeof Array.prototype.shuffle is 'undefined'
  Object.defineProperty Array.prototype, 'shuffle', value: () ->
    for currentIndex in [@length - 1 ... 0] by -1
      randomIndex = Math.floor(Math.random() * (currentIndex + 1))
      [@[currentIndex], @[randomIndex]] = [@[randomIndex], @[currentIndex]]
    @

if typeof Array.prototype.count is 'undefined'
  Object.defineProperty Array.prototype, 'count', value: (callbackFn = (() => true), initialValue = 0) ->
    @sum ((element) => if callbackFn(element) then 1 else 0), initialValue

if typeof Array.prototype.sum is 'undefined'
  Object.defineProperty Array.prototype, 'sum', value: (callbackFn = ((item) => item), initialValue = 0) ->
    @reduce ((sum, element) => sum + callbackFn(element)), initialValue

if typeof Array.prototype.product is 'undefined'
  Object.defineProperty Array.prototype, 'product', value: (callbackFn = ((item) => item), initialValue = 1) ->
    @reduce ((product, element) => product * callbackFn(element)), initialValue

if typeof Array.prototype.min is 'undefined'
  Object.defineProperty Array.prototype, 'min', value: (callbackFn = ((item) => item), initialValue = Infinity) ->
    @reduce ((min, element, _, array) => Math.min(min, callbackFn element, array)), initialValue

if typeof Array.prototype.max is 'undefined'
  Object.defineProperty Array.prototype, 'max', value: (callbackFn = ((item) => item), initialValue = -Infinity) ->
    @reduce ((max, element, _, array) => Math.max(max, callbackFn element, array)), initialValue

if typeof Array.prototype.reorder is 'undefined'
  Object.defineProperty Array.prototype, 'reorder', value: (callbackFn, thisArg) ->
    @reduce ((result, item) =>
      result[callbackFn.call(thisArg, item)] = item
      result), []

if typeof Array.prototype.transpose is 'undefined'
  Object.defineProperty Array.prototype, 'transpose', value: (callbackFn = ((_, index) => index), thisArg) ->
    keys = []
    @reduce ((result, array) =>
      array.forEach((item, index, array) =>
        key = callbackFn.call(thisArg, item, index, array)
        newIndex = keys.indexOf(key)
        if newIndex < 0 then (newIndex = keys.length; keys.push(key); result[newIndex] = [])
        result[newIndex].push(item))
      result), []

if typeof Array.prototype.group is 'undefined'
  Object.defineProperty Array.prototype, 'group', value: (callbackFn, thisArg) ->
    @reduce ((result, item, index, array) =>
      key = callbackFn.call(thisArg, item, index, array)
      if key of result then result[key].push(item) else result[key] = [item]
      result), {}

if typeof Array.prototype.groupToMap is 'undefined'
  Object.defineProperty Array.prototype, 'groupToMap', value: (callbackFn, thisArg) ->
    @reduce(((result, item, index, array) =>
      key = callbackFn.call(thisArg, item, index, array)
      if result.has(key) then result.get(key).push(item) else result.set(key, [item])
      result), new Map())
